import {CustomList} from "./CustomList";
import {CustomEdit} from "./CustomEdit";


export default {
    list: CustomList,
    edit: CustomEdit
};
